module.exports = __webpack_public_path__ + "img/pay-success-icon.848ff2fd.png";